import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { usersApi } from '@/api/users';
import { Button } from '@/components/ui/Button';
import { buildAccessText, loginURL } from '@/lib/accessText';

/**
 * Кнопка «скопировать данные для входа».
 *
 * ⚠️ ПАРОЛЬ ЗАПРАШИВАЕМ ПО НАЖАТИЮ, а не заранее для всего списка. Это выданный
 * платформой пароль; тянуть три десятка чужих паролей на экран только потому,
 * что список открыли, — лишнее.
 *
 * ⚠️ ПУСТОЙ ОТВЕТ — НЕ ПОЛОМКА. Человек мог сменить пароль сам, и тогда его не
 * знает никто, включая нас. Показываем причину словами, а не пустоту.
 */
export function AccessCopyButton({ userId, email }: { userId: string; email: string }) {
  const { t } = useTranslation();
  const [state, setState] = useState<'idle' | 'busy' | 'done' | 'none'>('idle');
  const [note, setNote] = useState('');

  const copy = async () => {
    setState('busy');
    setNote('');
    try {
      const res = await usersApi.getIssuedPassword(userId);
      if (!res.available || !res.password) {
        setState('none');
        setNote(res.reason || t('accessCopy.noPassword'));
        return;
      }
      await navigator.clipboard.writeText(buildAccessText(t, email, res.password, loginURL()));
      setState('done');
      window.setTimeout(() => setState('idle'), 2500);
    } catch {
      setState('none');
      setNote(t('accessCopy.failed'));
    }
  };

  return (
    <div className="flex flex-col items-end">
      <Button variant="ghost" size="sm" onClick={() => void copy()} disabled={state === 'busy'}>
        {state === 'done' ? t('accessCopy.done') : t('accessCopy.button')}
      </Button>
      {note && <span className="mt-0.5 max-w-[220px] text-right text-[11px] text-on-surface-variant">{note}</span>}
    </div>
  );
}
